<!--  评估关系、被评估人 -->
<template>
  <div
    v-if="timeoutCount && successCountDown"
    class="text-center mt300"
  >
    <yxt-progress
      :percentage="process"
      :status="progressStatus"
      :width="156"
      type="circle"
    >
      {{progressStr}}
    </yxt-progress>
    <div
      v-if="syncStatus > 0"
      class="mt8 color-gray-8"
    >{{ resultStr }}</div>
    <yxt-button
      v-if="syncStatus === 2"
      class="mt24"
      type="primary"
      size="middle"
      @click="syncAgain"
    >{{$t('pc_talent_lbl_again_relationship').d('再次同步')}}</yxt-button>
  </div>
  <div v-else-if="!successCountDown">
    <div class="gwnl-auto-wrap">
      <div class="mr32">
        <yxt-button
          type="primary"
          @click="addEvalUsers"
        >
          {{$t('pc_gwnl_eval_btn_addTesters'/* 添加测评人员 */)}}
        </yxt-button>
        <yxt-button
          plain
          @click="showImportRelation"
        >
          {{ importBatchTitle }}
        </yxt-button>
        <yxt-button
          :disabled="!multipleSelection.length"
          plain
          @click="batchDeleteRow"
        >
          {{ $t('pc_gwnl_global_batchDelete'/* 批量删除 */) }}
        </yxt-button>
      </div>
      <template v-if="!isOpenEnv">
        <yxt-input
          v-model="pager.keyword"
          :placeholder="$t('pc_eval_pleaseEnter').d('请输入')"
          size="medium"
          searchable
          clearable
          class="width305"
          @search="getList(1)"
        >
          <yxt-select
            slot="prepend"
            v-model="pager.type"
            size="small"
            class="w100"
          >
            <yxt-option
              :label="$t('pc_eval_tip_username_search').d('姓名')"
              :value="1"
            />
            <yxt-option
              :label="$t('pc_eval_tip_position_search').d('岗位')"
              :value="2"
            />
          </yxt-select>
        </yxt-input>
      </template>
    </div>
    <div class="select_table_wrap">
      <yxtbiz-eval-evaluator-table
        ref="multipleTable"
        :datas="tableData"
        :loading="loading"
        :validate="validate"
        @selection-change="handleSelectionChange"
        :scene="scene"
        :dataPermissionCode="evaluatorDataPermission"
        :functionCode="functionCode"
        :is-save="true"
        :id="id"
        :isSelfTest="isSelfTest"
        :relationList="relationList"
      />
      <div class="clearfix pb15">
        <yxtbiz-eval-pager
          :total.sync="pager.total"
          :page.sync="pager.offset"
          :limit.sync="pager.limit"
          @pagination="getList"
        />
      </div>
    </div>

    <yxtbiz-eval-import-drawer
      ref="importRelation"
      :title="importBatchTitle"
      :temp-url="tempUrl"
      i18n
      :import-methods="importMethods"
      @success="getList(1)"
    />
    <yxtbiz-eval-step-footer
      :operation="operation"
      footer-width="960px"
    />
    <yxtbiz-eval-select-thirdparty-user
      :show-model="type === 1"
      :visible.sync="addUsersVisible"
      :get-list="getUsers"
      :is-peer="showImportButton"
      :defaultRaw="userListAll"
      @selected="handleSelectedUsers"
    />
  </div>
</template>

<script>
import {
  getSyncEvalRelationProgress,
  syncEvalRelation
} from '../service.js';
import relationsMixins from '../mixins/relations';

const OPERATION_MAP = ['', 'disabled', 'prevDisabled', 'nextDisabled', 'publishDisabled'];
const HALF_HOUR_SECONDS = 1800;
export default {
  mixins: [relationsMixins],
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      multipleSelection: [],
      syncStatus: 0, // 同步状态 0-同步中 1-同步成功 2-同步异常
      process: 0,
      successCountDown: 3,
      syncResult: {
        success: 0,
        fail: 0
      },
      timeoutCount: 0
    };
  },
  computed: {
    progressStatus() {
      return ['success', 'success', 'exception'][this.syncStatus];
    },
    progressStr() {
      return [this.$t('pc_biz_eval_lbl_sync_loading' /* 正在同步中... */), this.$t('pc_biz_eval_work_sync_success' /* 同步成功 */), this.$t('pc_biz_eval_lbl_sync_exception' /* 同步异常 */)][this.syncStatus];
    },
    resultStr() {
      const result = this.syncResult.fail > 0 ? this.$t('pc_biz_eval_msg_sync_failed' /* 还有{0}人同步失败 */, [this.syncResult.fail]) : `${this.successCountDown}s`;
      return this.$t('pc_biz_eval_msg_assessment_relationship_sync_success' /* 评估关系成功同步{0}人，{1} */, [this.syncResult.success, result]);
    }
  },
  created() {
    this.getSyncProgress();
  },
  methods: {
    getSyncProgress() {
      getSyncEvalRelationProgress({
        evaluationId: this.id,
        orgId: window.localStorage.getItem('orgId') || '',
        isEdit: this.isEdit ? 1 : 0
      }).then(res => {
        this.timeoutCount++;
        // 同步状态，0-未同步（没有被评估人），1-同步中(显示进度条)，2-同步完成(显示进度条)，3-已同步（已经有被评估人了） -1-无需同步（不满足评估条件）
        if (!res || !res.autoSync || [3, -1].includes(res.syncState)) {
          this.successCountDown = 0;
          this.init();
          return;
        }
        if (res.syncState === 2) {
          this.syncStatus = res.fail > 0 ? 2 : 1;
          this.syncResult = {
            success: res.finish,
            fail: res.fail
          };
          this.process = res.total > 0 ? parseInt(100 * res.finish / res.total, 0) : 100;
          this.syncStatus === 1 && this.syncSuccessTimer(); // 同步完成
          return;
        }
        if ([0, 1].includes(res.syncState)) {
          this.process = (res.syncState === 0 || res.total === 0) ? 0 : parseInt((100 * (res.fail + res.finish) / res.total), 0);
          this.timeoutCount < HALF_HOUR_SECONDS && setTimeout(this.getSyncProgress, 1000);
        }
      });
    },
    syncSuccessTimer() {
      if (this.successCountDown > 0) {
        setTimeout(() => {
          this.successCountDown--;
          this.syncSuccessTimer();
        }, 1000);
      } else {
        this.init();
      }
    },
    syncAgain() {
      this.timeoutCount = 0;
      this.syncStatus = 0;
      this.syncResult = {
        success: 0,
        fail: 0
      };
      this.process = 0;
      syncEvalRelation({
        evaluationId: this.id,
        orgId: window.localStorage.getItem('orgId') || ''
      }).then(() => {
        setTimeout(this.getSyncProgress, 1000);
      });
    },
    setOperateVal(type, val) {
      this.operation[`${OPERATION_MAP[type]}`] = val;
    }
  }
};

</script>
<style lang="scss" scoped>
// 按钮筛选器自动换行
.gwnl-auto-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > div {
    margin-bottom: 16px;
  }
}
.select_table_wrap {
  padding-bottom: 56px;
}
</style>
